import React, { useEffect, useRef, useState, useCallback } from "react";
import io from "socket.io-client";
import { Button, CircularProgress, Grid, Stack } from "@mui/material";
import captureVideoFrame from "capture-video-frame";
import { CallEndRounded } from "@mui/icons-material";
import UnmuteIcon from "@mui/icons-material/Mic";
import MuteIcon from "@mui/icons-material/MicOff";
import DrawingBoard from "../DrawingBoard";
import { useCookies } from "react-cookie";
import "./webrctcustomer.css";

const Room = React.memo((props) => {
  const { conf, onClose, OnError } = props;
  const audioCall = conf.audio;
  const videoCall = conf.video;
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const videoBit = 1000;
  const audioBit = 50;
  // my video ref (engineer/customer)
  const userVideo = useRef();
  // other person video ref
  const partnerVideo = useRef();
  //RTC peer connection ref
  const peerRef = useRef();
  //socket ref
  const socketRef = useRef();
  //just to have track of other user
  //const otherUser = useRef();
  //to have the media stream ref
  const userStream = useRef();
  //this is used on for engineer and to have annotation
  const drawingBoard = useRef();
  //to store the roomID
  const roomId = useRef("");
  //datachannel ref
  const dataChannel = useRef();
  //the mobile device dimensions
  const [dim, setDim] = useState();
  //start webrtc only after getting userMedia
  const [permissionGranted, SetpermissionGranted] = useState(false);
  // to pause video
  const [paused, setPaused] = useState(false);
  //for engineer to store the customer is having video or audio call
  const [callType, setCallType] = useState(videoCall ? "video" : "audio");
  //to mute the stream
  const [mute, setMute] = useState(false);
  //just wanted to rerender can be ignored
  const [callReceived, setCallReceived] = useState(false);
  const [dummy, setDummy] = useState();
  const [updateCookies, setUpdateCookies] = useState();
  const [orientation, setOrientation] = useState(false);
  const connectionError = useRef(false);
  //to see if the react application is opend in mobile or desktop
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  var mediaConstraints = {};
  var rejoinCount = 0;
  useEffect(() => {
    //add required constraints
    if (audioCall) {
      mediaConstraints["audio"] = {
        autoGainControl: true,
        channelCount: 2,
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 8000,
        sampleSize: 16,
      };
      mediaConstraints["video"] = false;
    }
    if (videoCall) {
      mediaConstraints["video"] = {
        width: window.innerHeight,
        height: window.innerWidth,
      };
    } else {
      mediaConstraints["video"] = false;
    }
    if (isMobile) {
      if (videoCall) {
        mediaConstraints["video"]["facingMode"] = {
          exact: "environment",
        };
      }
    }
    // get user media
    navigator.mediaDevices
      .getUserMedia(mediaConstraints)
      .then((stream) => {
        userVideo.current.srcObject = stream;
        userStream.current = stream;
        SetpermissionGranted(true);
      })
      .catch((e) => {
        SetpermissionGranted(false);
        disconnect();
        handelDisconnect();
        OnError(e);
      });

    console.log("the mobile is", isMobile);
  }, []);

  useEffect(() => {
    if (permissionGranted) {
      //connect to socket server
      socketRef.current = io(conf.socketIoPath, {
        auth: {
          user: "shashank",
          cred: "123",
        },
      });
      // lockscreenorientation();
      socketRef.current.on("connnection established", (args) => {
        if (roomId.current === "") {
          if (conf.roomId !== "") {
            roomId.current = conf.roomId;
            //customer will join to the room, if room Id is available directly you can send join
            socketRef.current.emit("join", {
              roomId: conf.roomId,
              height: window.innerHeight,
              width: window.innerWidth,
              type: videoCall ? "video" : "audio",
            });
          }
        } else {
          let sid = localStorage.getItem("sid");
          if (sid !== null) {
            socketRef.current.emit("getRoomIdFromSession", {
              sessionID: sid,
            });
          } else {
            disconnect();
            handelDisconnect();
          }
        }
      });
      addConnectionErrorListener();
      AddListenerToSocket();
      //some UI changes based on the video dimensions
      userVideo.current.height = window.innerHeight;
      userVideo.current.width = window.innerWidth;
      let top =
        document.getElementById("parentElement").getBoundingClientRect().top +
        "px";
      userVideo.current.style.top = top;
      partnerVideo.current.style.top = top;
      let canvas = document.getElementById("my-canvas").style;
      canvas.top = top;
      canvas.left = partnerVideo.current.getBoundingClientRect().left + "px";
    }
    return () => {
    };
  }, [permissionGranted]);

  

  const addConnectionErrorListener = () => {
    socketRef.current.on("connect_error", (err) => {
      if (!connectionError.current) {
        connectionError.current = true;
        if (peerRef.current) peerRef.current.close();
        setCallReceived(false);
      }
    });
  };

  const AddListenerToSocket = () => {
    socketRef.current.on("user joined", (args) => {
      localStorage.setItem("sid", args.sessionId);
    });

    socketRef.current.on("yourRoomId", (args) => {
      socketRef.current.emit("join", {
        roomId: args.roomId,
        height: window.innerHeight,
        width: window.innerWidth,
        type: videoCall ? "video" : "audio",
      });
    });
    //once customer sends join
    //customer will receive user joined
    //engineer will receive other user
    // any error occured in socker server will be received here
    socketRef.current.on("error occured", (args) => {
      switch (args.message) {
        case "agent is in anther call please wait retry again":
          socketRef.current.emit("join", {
            roomId: args.roomId,
            height: window.innerHeight,
            width: window.innerWidth,
            type: videoCall ? "video" : "audio",
          });
          break;
     
        default:
          alert(args.message);
          handelDisconnect();
          break;
      }
    });

    // socketRef.current.on("roomfull", (args) => {
    //   alert("room is full");
    //  });
    //whenever offer is received in customer's end handel Receive the call
    socketRef.current.on("offer", handleRecieveCall);
    //on ice candidate exchange event
    socketRef.current.on("ice-candidate", handleNewICECandidateMsg);
    //whenever any one cliks on disconnect button
    socketRef.current.on("callDisconnect", handelDisconnect);

    socketRef.current.on("callReceived", () => {
      setCallReceived(true);
    });
    socketRef.current.on("callRejected", (args) => {
      setCallReceived(false);
      if (peerRef.current) {
        peerRef.current.close();
        alert("engineers are not available")
      }
      socketRef.current.emit("join", {
        roomId: args.roomId,
        height: window.innerHeight,
        width: window.innerWidth,
        type: videoCall ? "video" : "audio",
      });
      roomId.current = args.roomId;
    });
  };
  const pauseCB = useCallback(() => {
    const img = document.getElementById("my-canvas");
    img
      .getContext("2d")
      .clearRect(
        0,
        0,
        img.getBoundingClientRect().width,
        img.getBoundingClientRect().height
      );
    if (img.style.backgroundImage !== "") {
      setPaused(false);
      img.style.backgroundImage = "";
    } else {
      setPaused(true);
      const frame = captureVideoFrame(
        isMobile ? "userVideo" : "partnerVideo",
        "png"
      );
      img.style.backgroundImage = `url(${frame.dataUri})`;
    }
  }, [paused, dim]);

  const CreatePeer = (roomId) => {
    //create peer connection
    const peer = new RTCPeerConnection({
      iceServers: conf.iceServers,
    });
    //create datachannal
    dataChannel.current = peer.createDataChannel("ch");
    //have required handlers for datachannal (open,close,message,error)
    configDC(dataChannel.current);
    //handle on Ice candidate event
    peer.onicecandidate = handleICECandidateEvent;
    //handle on ontrack  event
    peer.ontrack = handleTrackEvent;
    // on datachannal event
    peer.ondatachannel = handelOnDataChannel;
    return peer;
  };
  const handelOnDataChannel = (e) => {
    //save the ref in datachannal
    dataChannel.current = e.channel;
    configDC(dataChannel.current);
  };
  const configDC = (dataChannel) => {
    //this is self explainatory
    dataChannel.onopen = handelOnDataChannelOpen;
    dataChannel.onclose = handelOnDataChannelClose;
    dataChannel.onmessage = handelOnDataChannelMessage;
    dataChannel.onerror = handelOnDataChannelError;
  };
  const handelOnDataChannelOpen = (e) => {
    pauseCB();
    pauseCB();

  };
  const handelOnDataChannelClose = (e) => {
  };
  const handelOnDataChannelError = (e) => {
  };
  const handelOnDataChannelMessage = (args) => {
    let data = JSON.parse(args.data);
    if (data.type === "mute") {
      //here this event will receive only when enginner send mute
      //so here the partner audio will be muted
      partnerVideo.current.muted = data.muteValue;
    } else if (data.type === "pause") {
      //here this event will receive only when enginner send mute
      //here the video will be paused as there is only customer video
      pauseCB();
    } else drawingBoard.current.getData(args.data);
  };
  const handleRecieveCall = (args) => {
    //this is at customer end
    //upon receiveing the event create peer connection
    peerRef.current = CreatePeer();
    //create description
    const desc = new RTCSessionDescription(args.sdp);
    //set remote description to the one created
    //add stream to the connection
    peerRef.current
      .setRemoteDescription(desc)
      .then(() => {
        userStream.current.getTracks().forEach((track) => {
          peerRef.current.addTrack(track, userStream.current);
        });
      })
      .then(() => {
        //create answer
        return peerRef.current.createAnswer();
      })
      .then((answer) => {
        //set local descrition to answer
        answer.sdp = addBitRate(answer.sdp, "video", videoBit);
        answer.sdp = addBitRate(answer.sdp, "audio", audioBit);
        return peerRef.current.setLocalDescription(answer);
      })
      .then(() => {
        //send the answer to engineer
        const payload = {
          roomId: args.roomId,
          sdp: peerRef.current.localDescription,
        };
        socketRef.current.emit("answer", payload);
        connectionError.current = false;
        //just to rerender the component to update the video dimension from customer at
      });
  };
  const addBitRate = (sdp, media, bitRate) => {
    let lines = sdp.split("\n");
    let lineIndex = -1;
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i];
      if (line.indexOf("m=" + media) === 0) {
        lineIndex = i;
        break;
      }
    }
    lines.splice(lineIndex + 2, 0, "b=AS:" + bitRate);
    let finalSDP = "";
    lines.map((c, index) => {
      if (index !== lines.length - 1) {
        finalSDP += c + "\n";
      } else {
        finalSDP += c;
      }
    });
    return finalSDP;
  };
  const handleICECandidateEvent = (e) => {
    if (e.candidate) {
      const payload = {
        roomId: roomId.current,
        candidate: e.candidate,
      };
      socketRef.current.emit("ice-candidate", payload);
    }
  };
  const handleNewICECandidateMsg = (incoming) => {
    const candidate = new RTCIceCandidate(incoming.candidate);
    peerRef.current.addIceCandidate(candidate).catch((e) => console.log(e));
  };
  const handleTrackEvent = (e) => {

    partnerVideo.current.srcObject = e.streams[0];
  };
  // whenever anyonce clicks on the disconnect disconnect peer and socket
  const handelDisconnect = () => {
    removeCookie("user");
    localStorage.removeItem("sid");
    if (socketRef.current) socketRef.current.close();
    if (peerRef.current) peerRef.current.close();
    onClose();
  };
  //when any one clicks on the button then emit that to server intern to user in the room
  const disconnect = () => {
    if (socketRef.current)
      socketRef.current.emit("disconnectCall", { roomId: roomId.current });
  };
  const muteVideo = (args) => {
    if (dataChannel.current && dataChannel.current.readyState === "open") {
      dataChannel.current.send(
        JSON.stringify({ type: "mute", muteValue: args })
      );
      setMute(args);
    }
  };
 

  useEffect(() => {
    window.addEventListener("orientationchange", lockorientation);

    return () => {
      window.removeEventListener("orientationchange", lockorientation);
    };
  }, []);

  const lockorientation = () => {
    if (window.orientation !== 0) {
      window.screen.orientation.lock("portrait");
      setOrientation(true);
      // alert("please keep the phone in potrait mode")
    }
  };
  return (
    <>
      <Grid
        container
        id="parentElement"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <video
          autoPlay
          playsInline
          ref={partnerVideo}
          id="partnerVideo"
          width={dim ? dim.width : 0}
          height={dim ? dim.height : 0}
          style={{
            position: "absolute",
            zIndex: 1,
            display: conf.isEngineer && callType === "video" ? "block" : "none",
          }}
        />
        <video
          autoPlay
          playsInline
          ref={userVideo}
          id="userVideo"
          muted
          style={{
            position: "absolute",
            zIndex: 2,
            display:
              !conf.isEngineer && videoCall && callReceived ? "block" : "none",
          }}
        />
        {!callReceived && (
          <Grid
            container
            height="100svh"
            justifyContent="center"
            alignItems="center"
            style={{ color: "white" }}
          >
            <CircularProgress />
            Please wait while we connect to our engineer...
          </Grid>
        )}
        {permissionGranted && callReceived && (
          <Stack
            spacing="1"
            direction="row"
            style={{
              position: "absolute",
              zIndex: 100,
              top: window.innerHeight - 50,
            }}
          >
            <Button
              style={{ borderRadius: "20px" }}
              color="error"
              variant="contained"
              onClick={() => disconnect()}
            >
              <CallEndRounded />
            </Button>
            <Button
              style={{ borderRadius: "20px" }}
              variant="contained"
              onClick={() => muteVideo(!mute)}
            >
              {mute ? <MuteIcon /> : <UnmuteIcon />}
            </Button>
          </Stack>
        )}
        <DrawingBoard
          ref={drawingBoard}
          isMobile={isMobile}
          dataChannel={dataChannel.current}
          disconnect={disconnect}
          callDimensions={
            conf.isEngineer
              ? dim
                ? dim
                : {
                    width: 0,
                    height: 0,
                  }
              : {
                  width: window.innerWidth,
                  height: window.innerHeight,
                }
          }
          pause={paused}
          pauseCB={pauseCB}
          video={callType}
        />
      </Grid>
    </>
  );
});
export default Room;
